// import { DownOutlined } from '@ant-design/icons'
// // import { Popover } from 'antd'
// import { Popover } from '@mui/material'
// import React, { useState , useCallback, useMemo} from 'react'
// import HeaderMenus from '../../../utils/HeaderMenus'

// const DropDownButton = ({user_name}) => {
//     const [open, setOpen] = useState(false);
//     const handleOpenChange = useCallback( (newOpen) => {
//         setOpen(newOpen);
//     },[open])
    
//     // const hide = () => {
//     //     setOpen(false);
//     // };
//     const hide = useCallback(() => {
//     setOpen(false);
// }, [open]);
// const memoizedHeaderMenus = useMemo(() => <HeaderMenus hide={hide} />, [hide]);


//     return (
//         // <Popover showArrow={false}  
        
//         // overlayInnerStyle={{width:'100%', padding:0}} placement="bottomRight"
//         //  content={memoizedHeaderMenus} trigger="click" open={open} onOpenChange={handleOpenChange} >
//         //     <button type='button' className="leading-4 font-bold text-sm text-secondary">
//         //         <div className="flex gap-2 items-center">
//         //             <div className="sm:hidden">Hello! {user_name?.full_name.toUpperCase()}</div>
//         //             <DownOutlined />
//         //         </div>
//         //     </button>
//         // </Popover>
//         <Popover
//   id={id}
//   open={open}
//   anchorEl={anchorEl}
//   onClose={handleClose}
//   anchorOrigin={{
//     vertical: 'bottom',
//     horizontal: 'left',
//   }}
// >
//   <Typography sx={{ p: 2 }}>               <DownOutlined />
// </Typography>
// </Popover>

//     )
// }

// export default React.memo(DropDownButton)
import { DownOutlined } from "@ant-design/icons"
import { Popover } from "@mui/material"
import React, { useState, useCallback, useMemo, useRef } from "react"
import HeaderMenus from "../../../utils/HeaderMenus"
import { toTitleCase } from "../../../utils/formatName"

const DropDownButton = ({ user_name }) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const handleClick = useCallback((event) => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const hide = useCallback(() => {
    setOpen(false)
  }, [])

  const memoizedHeaderMenus = useMemo(() => <HeaderMenus hide={hide} />, [hide])

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        className="leading-4 font-bold text-sm text-secondary"
        onClick={handleClick}
        aria-describedby={open ? "dropdown-popover" : undefined}
      >
        <div className="flex gap-2 items-center">
          <div className="sm:hidden">Hello! {toTitleCase(user_name?.full_name)}</div>
          <DownOutlined />
        </div>
      </button>

      <Popover
        id="dropdown-popover"
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableAutoFocus
        disableEnforceFocus
        sx={{
          "& .MuiPaper-root": {
            marginTop: 1,
            minWidth: 200,
            boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
          },
        }}
      >
        {memoizedHeaderMenus}
      </Popover>
    </>
  )
}

export default React.memo(DropDownButton)
